import React, { Component } from "react";
import {
  withStyles,
  Card,
  CardHeader,
  Avatar,
  Typography,
  CardContent,
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  OutlinedInput,
  MenuItem,
  CardActions,
  Button,
} from "@material-ui/core";
import Add from "@material-ui/icons/Add";

import { PostData, GetData } from "../../../api/service";
import Snack from "../../Snackbar/Snack";
import FileUpload from "../../AddNew/FileUpload";

const styles = (theme) => ({
  textField: {
    width: "100%",
  },
  formControl: {
    width: "100%",
    marginTop: theme.spacing.unit * 2,
  },
});

class AddIqacFileItem extends Component {
  state = {
    groups: [],
    group_id: "",
    title: "",
    image: [],
    index1: "",

    isLoaded: true,
    open: false,
    message: "",
  };

  __getInitialState() {
    this.setState({
      group_id: "",
      title: "",
      image: [],
      index1: "",
    });
  }

  componentDidMount() {
    GetData(`/${this.props.apikey}/getiqacfilegroup`).then((resp) => {
      this.setState({
        groups: resp,
        isLoaded: true,
      });
    });
  }

  onSetFile = (data) => {
    //console.log(data)
    this.setState({
      image: data,
    });
  };

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleRichChange = (name, data) => {
    this.setState({
      [name]: data,
    });
  };

  onSubmit = (e) => {
    e.preventDefault();

    let data = {
      ...this.state,
    };

    //console.log(data);

    PostData(`/${this.props.apikey}/addiqacfilegroupitem`, data)
      .then((resp) => {
        //console.log(resp)
        this.setState({
          open: true,
          message: resp,
        });
      })
      .then(() => {
        this.__getInitialState();
      });
  };

  render() {
    let { classes } = this.props;

    return (
      <div>
        {this.state.open ? (
          <Snack
            open={this.state.open}
            handleClose={() => {
              this.setState({
                open: false,
                message: "",
              });
            }}
            message={this.state.message}
          />
        ) : null}
        <form onSubmit={this.onSubmit}>
          <Card>
            <CardHeader
              avatar={
                <Avatar>
                  <Add />
                </Avatar>
              }
              title={
                <Typography variant="h6">
                  Add New IQAC File Group Item
                </Typography>
              }
            />
            <CardContent>
              <Grid container spacing={24}>
                <Grid item lg={12} sm={12}>
                  <FormControl
                    variant="outlined"
                    className={classes.formControl}
                  >
                    <InputLabel>File Group</InputLabel>
                    <Select
                      value={this.state.group_id}
                      onChange={this.handleChange}
                      input={<OutlinedInput labelWidth={200} name="group_id" />}
                      required={true}
                      name="group_id"
                    >
                      <MenuItem value="">
                        <em>None</em>
                      </MenuItem>
                      {this.state.groups.map((el, index) => (
                        <MenuItem key={index} value={el.id}>
                          {el.group_name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item lg={6} sm={12}>
                  <TextField
                    id="outlined-multiline-flexible"
                    label="Title"
                    fullWidth
                    multiline
                    rowsMax="4"
                    name="title"
                    value={this.state.title}
                    onChange={this.handleChange}
                    variant="outlined"
                  />
                </Grid>

                <Grid item lg={6} sm={12}>
                  <TextField
                    id="outlined-multiline-flexible"
                    label="Order"
                    fullWidth
                    multiline
                    rowsMax="4"
                    name="index1"
                    value={this.state.index1}
                    onChange={this.handleChange}
                    variant="outlined"
                  />
                </Grid>
                <Grid item lg={12} sm={12}>
                  <FileUpload
                    dp={this.state.image}
                    apikey={this.props.apikey}
                    type={`IQAC_FILE`}
                    setDp={this.onSetFile.bind(this)}
                  />
                </Grid>
              </Grid>
            </CardContent>

            <CardActions>
              <Button variant="outlined" color="primary" type="submit">
                Submit
              </Button>
            </CardActions>
          </Card>
        </form>
      </div>
    );
  }
}

export default withStyles(styles)(AddIqacFileItem);



// WEBPACK FOOTER //
// ./src/Components/Iqac/FileItem/AddIqacFileItem.js